module.exports = __webpack_public_path__ + "static/media/custom-box-order.aa59cdca.JPG";